export { DashboardRenderer, getAvailableWidgets } from './DashboardRenderer'
export {
  WIDGET_REGISTRY,
  getWidget,
  getWidgetsByCategory,
  getWidgetKeys,
  getWidgetsForCategory,
} from './widget-registry'
export * from './widgets'
